import { Person } from '@fs/zion-person'
import { Separator, Skeleton } from '@fs/zion-ui'
import React from 'react'
import SkeletonAnimationSyncDecorator from '../../../../common/SkeletonAnimationSyncDecorator'

export default function OtherRelationshipHeaderSkeleton(): JSX.Element {
  return (
    <SkeletonAnimationSyncDecorator>
      <Skeleton.Paragraph maxWidth={200} />
      <Separator size="nano" />
      <Person
        noBoldName
        loading
        personObj={{}}
        componentSize="sm"
        hideLifespan
        hidePid
        avatarSize="smaller"
        openPersonOverlay
      />

      <Separator size="xxs" />

      <Skeleton.Paragraph maxWidth={200} />
      <Separator size="nano" />
      <Person
        noBoldName
        loading
        personObj={{}}
        componentSize="sm"
        hideLifespan
        hidePid
        avatarSize="smaller"
        openPersonOverlay
      />

      <Separator size="xxs" />
    </SkeletonAnimationSyncDecorator>
  )
}
